
import { defineComponent } from "vue";
import Avatar from "primevue/avatar";
import Badge from "primevue/badge";
import Listbox from "primevue/listbox";
import KnListButtonRenderer from "./KnListButtonRenderer.vue";
import Menu from "primevue/menu";
import { formatDateWithLocale } from "@/helpers/commons/localeHelper";

export default defineComponent({
  name: "kn-list-box",
  components: {
    Avatar,
    Badge,
    KnListButtonRenderer,
    Listbox,
    Menu,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    options: Array,
    selected: Object,
  },
  data() {
    return {
      filterValue: "",
      selectedSort: "label",
      selectedDirection: "",
      sortedOptions: [] as Array<any>,
    };
  },
  emits: ["click"],
  created() {
    this.selectedSort = this.settings.defaultSortField || "label";
    this.sort(null, this.selectedSort, true);
  },
  updated() {
    this.sort(null, this.selectedSort, true);
  },
  computed: {},
  methods: {
    searchFilter(e) {
      this.filterValue = e.target.value;
      this.sortedOptions = this.options ? this.options.filter((i) => JSON.stringify(i).indexOf(this.filterValue) > -1) : [];
    },
    clickedButton(e, item) {
      const emits = e.item && e.item.emits;
      e.item = item;
      this.$emit(emits || "click", e);
    },
    getBorderClass(item): string {
      if (this.settings.statusBorder) {
        return "kn-list-item-" + this.settings.statusBorder.values[item[this.settings.statusBorder.property]];
      } else return "";
    },
    isItemSelected(option) {
      if (this.selected) {
        if (this.settings.selectProperty && this.selected[this.settings.selectProperty]) {
          return this.selected[this.settings.selectProperty] == option[this.settings.selectProperty];
        } else {
          return this.selected == option;
        }
      } else return false;
    },
    toggleSort(e) {
      // eslint-disable-next-line
      // @ts-ignore
      this.$refs.sortMenu.toggle(e);
    },
    sort(e, item, desc?) {
      if (this.settings.fullTextSearch) this.sortedOptions = this.filterValue ? this.sortedOptions : this.options ? this.options : [];
      else this.sortedOptions = this.options ? this.options : [];
      if (this.selectedSort === item) this.selectedDirection = this.selectedDirection === "desc" ? "asc" : "desc";
      else {
        this.selectedSort = item;
        this.selectedDirection = "desc";
      }

      if (e || (!e && this.selectedDirection === "")) {
        if (this.selectedDirection === "") this.selectedDirection = "desc";
        if (desc || this.selectedDirection === "desc") this.sortedOptions.sort((a: any, b: any) => (a[this.selectedSort] > b[this.selectedSort] ? 1 : -1));
        else this.sortedOptions.sort((a: any, b: any) => (a[this.selectedSort] > b[this.selectedSort] ? -1 : 1));
      }
    },
    getTime(ms) {
      return formatDateWithLocale(ms);
    },
  },
});
